import Page from '@/components/Page/index.ts';
import { getActiveCompetition, competitionWinnersQuery } from '@/lib/api/requests.ts';
import { getQueryClient } from '@/lib/query-client-context.ts';

import type { Route } from './+types/LandingPage';
import { CompetitionsSection } from './_sections/CompetitionsSection.tsx';
import { TimerSection } from './_sections/TimerSection.tsx';
import { TopSection } from './_sections/TopSection.tsx';

export async function loader({ context }: Route.LoaderArgs) {
  const queryClient = getQueryClient(context);
  const competitions = await queryClient.query(competitionWinnersQuery());
  const activeCompetition = await getActiveCompetition(competitions);
  const winners = competitions.find((c) => c.slug === 'march_2026_campaign')?.winners;
  const index = competitions.findIndex((c) => c.slug === 'march_2026_campaign');
  const previousCompetitions = competitions.slice(index + 1);
  const allWinners = competitions.flatMap((d) => d.winners);
  return { activeCompetition, winners, previousCompetitions, allWinners };
}

export default function LandingPage({ loaderData }: Route.ComponentProps) {
  const { activeCompetition, winners, previousCompetitions, allWinners } = loaderData;

  return (
    <Page title="Påske-trekning">
      <div className="w-full bg-white">
        <TopSection
          activeCompetition={activeCompetition}
          winners={winners}
          allWinners={allWinners}
        />
        <TimerSection activeCompetition={activeCompetition} />
        <CompetitionsSection competitions={previousCompetitions} />
      </div>
    </Page>
  );
}
